// Wrap all registered trademark symbols in sup tags
(function() {
  // Early exit if no ® symbols on page
  if (!document.body.textContent.includes('®')) return;

  function wrapRegisteredSymbols() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          const parent = node.parentElement;
          // Skip script, style, and already wrapped elements
          if (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE' || parent.tagName === 'SUP') {
            return NodeFilter.FILTER_REJECT;
          }
          return node.textContent.includes('®') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodesToProcess = [];
    let node;
    while (node = walker.nextNode()) {
      nodesToProcess.push(node);
    }

    nodesToProcess.forEach(function(textNode) {
      const fragment = document.createDocumentFragment();
      const parts = textNode.textContent.split('®');

      parts.forEach(function(part, index) {
        fragment.appendChild(document.createTextNode(part));
        if (index < parts.length - 1) {
          const sup = document.createElement('sup');
          sup.textContent = '®';
          fragment.appendChild(sup);
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  // Run after DOM is ready but without blocking
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapRegisteredSymbols);
  } else {
    // Use requestIdleCallback for better performance if available
    if ('requestIdleCallback' in window) {
      requestIdleCallback(wrapRegisteredSymbols, { timeout: 2000 });
    } else {
      setTimeout(wrapRegisteredSymbols, 0);
    }
  }
})();
